import { Serializable } from '../../../core/models/serializable';
export class SubscriberFilterModel
  implements Serializable<SubscriberFilterModel>
{
  fromObject(object: any): SubscriberFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      SubscriberStatusId: this.subscriberStatusId,
      Email: this.email,
      ProviderWebsiteId: this.providerWebsiteId,
    };
    return result;
  }

  public subscriberStatusId: number;
  public email: string;
  public providerWebsiteId: number;

  constructor() {
    this.subscriberStatusId = 1;
    this.email = null;
    this.providerWebsiteId = null;
  }
}
